import { ISelectOption } from "src/@types/form";

// Utility type for asserting the return type
type Assert<T> = T extends string[] ? ISelectOption[] : ISelectOption;

// The getSelectedOptions function takes two parameters:
// 1. selectedValues: T - the selected option values (string or array of strings)
// 2. options: ISelectOption[] - an array of option objects
export const getSelectedOptions = <T extends string | string[]>(
  selectedValues: T,
  options: ISelectOption[]
): Assert<T> => {
  // If selectedValues is an array
  if (Array.isArray(selectedValues)) {
    // Filter the options array, keeping only the objects whose value property is included in selectedValues
    const selectedOptions = options.filter((option) =>
      selectedValues?.includes(String(option.value))
    );
    // Return the filtered selectedOptions array with the type determined by Assert<T>
    return selectedOptions as Assert<T>;
  }
  // If selectedValues is not an array (i.e., it's a string)
  // Find the first object in the options array whose value property matches selectedValues
  return options.find((option) => option.value === selectedValues) as Assert<T>;
};
